import { useState, useCallback, useEffect } from 'react'
import { readGlobalServices } from '../../../../../../Super-Admin/Global Services/utils/api'
import { GlobalServicesEnums } from '../../../../../../Super-Admin/Global Services/utils/enums'
import { message } from 'antd'
import { handleError } from '../../../../../../lib/errorHandler'

const useServices = ({ recordData }) => {
  const [activeServices, setActiveServices] = useState(recordData?.servicesOffered || [])
  const [searchQuery, setSearchQuery] = useState('')
  const [expandedCategories, setExpandedCategories] = useState([])
  const [globalServices, setGlobalServices] = useState([])

  useEffect(() => {
    getglobalServices()
  }, [])

  useEffect(() => {
    const newServicesOffered = recordData?.servicesOffered || []

    // Only update if the services offered array has actually changed
    setActiveServices((prevActiveServices) => {
      const currentSet = new Set(prevActiveServices)
      const newSet = new Set(newServicesOffered)

      const isDifferent =
        prevActiveServices.length !== newServicesOffered.length ||
        !prevActiveServices.every((id) => newSet.has(id)) ||
        !newServicesOffered.every((id) => currentSet.has(id))

      return isDifferent ? newServicesOffered : prevActiveServices
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordData?.servicesOffered])

  const getglobalServices = async () => {
    try {
      const tmpServices = await readGlobalServices()
      // const tmpProfile = [] // TODO: need to read here
      setGlobalServices(tmpServices)
    } catch (error) {
      message.error(handleError(error, true))
    }
  }
  const toggleService = (serviceId) => {
    let tmpActiveServices = JSON.parse(JSON.stringify(activeServices))
    let tmpServiceIndex = tmpActiveServices.findIndex((s) => s === serviceId)
    if (tmpServiceIndex === -1) {
      tmpActiveServices.push(serviceId)
    } else {
      tmpActiveServices.splice(tmpServiceIndex, 1)
    }
    setActiveServices(tmpActiveServices)
  }
  const toggleCategoryExpansion = (categoryKey) => {
    let tmpExpandedCategories = JSON.parse(JSON.stringify(expandedCategories))
    let tmpCategoryIndex = tmpExpandedCategories.findIndex((c) => c === categoryKey)
    if (tmpCategoryIndex === -1) {
      tmpExpandedCategories.push(categoryKey)
    } else {
      tmpExpandedCategories.splice(tmpCategoryIndex, 1)
    }
    setExpandedCategories(tmpExpandedCategories)
  }

  // Expand all categories
  const expandAllCategories = useCallback(() => {
    setExpandedCategories(GlobalServicesEnums.categories.map((c) => c.value))
  }, [])
  // Collapse all categories
  const collapseAllCategories = useCallback(() => {
    setExpandedCategories([])
  }, [])

  // Get active services count
  const activeServicesCount = activeServices.length

  // Get category count
  const categoryCount = GlobalServicesEnums.categories.length

  // Clear all active services
  const clearAllServices = () => {
    setActiveServices([])
  }

  const handleToggleAllCategoryServices = (isActive, categoryKey) => {
    // Get all service IDs for this category
    const categoryServiceIds = globalServices.filter((i) => i.category === categoryKey).map((i) => i._id)

    if (isActive) {
      // Add all services from this category to existing active services
      setActiveServices((prevActive) => [...new Set([...prevActive, ...categoryServiceIds])])
    } else {
      // Remove all services from this category from active services
      setActiveServices((prevActive) => prevActive.filter((id) => !categoryServiceIds.includes(id)))
    }
  }

  // Set all services as active
  const activateAllServices = () => {
    setActiveServices(globalServices.map((i) => i._id))
  }

  // Update active services from external source (e.g., form data)
  const updateActiveServices = (serviceIds) => {}

  return {
    // State
    activeServices,
    searchQuery,
    expandedCategories,
    globalServices,
    activeServicesCount,
    categoryCount,
    handleToggleAllCategoryServices,
    // Actions
    setSearchQuery,
    toggleService,
    toggleCategoryExpansion,
    expandAllCategories,
    collapseAllCategories,
    clearAllServices,
    activateAllServices,
    updateActiveServices
  }
}

export default useServices
